class Accordion {
  accordion: HTMLElement;
  buttons: NodeListOf<HTMLButtonElement>;

  constructor(accordion: HTMLElement) {
    this.accordion = accordion;
    this.buttons = accordion.querySelectorAll<HTMLButtonElement>(".accordion__btn");

    if (this.buttons.length === 0) return;

    this.init();
  }

  init() {
    const firstBtn = this.buttons[0];
    const firstList = firstBtn?.nextElementSibling as HTMLElement | null;

    if (
      firstBtn &&
      firstList &&
      firstList.classList.contains("accordion__list")
    ) {
      firstList.classList.add("is-open");
      firstBtn.classList.add("active");
    }

    this.buttons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const list = btn.nextElementSibling as HTMLElement | null;

        if (!list || !list.classList.contains("accordion__list")) return;

        const isOpen = list.classList.toggle("is-open");
        btn.classList.toggle("active", isOpen);
      });
    });
  }
}

document.querySelectorAll<HTMLElement>(".accordion").forEach((acc) => {
  new Accordion(acc);
});
